module.exports = __webpack_public_path__ + "img/head_vertical.a20d5e15.png";